import Step3 from './step3';

export default Step3;
